import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLoader } from "../context/loaderContext";

const DefaultHome = () => {

    const { showLoader, hideLoader } = useLoader();
    const [isOpen, setIsOpen] = useState(false);

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        showLoader();
        const handleScroll = () => {
            const scroll = window.scrollY;
            const header = document.getElementById("sticky-header");

            if (!header?.classList) {
                return;
            }

            if (scroll < 100) {
                header.classList.remove("sticky");
            } else {
                header.classList.add("sticky");
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        // Load the external script
        const script = document.createElement("script");
        script.src = "/siteadmin/js/particls.chart1.js";
        script.async = true;

        script.onload = () => {
            setTimeout(() => {
                if (window.particleground) {
                    window.particleground(document.getElementById("particles"), {
                        dotColor: "#FFBC00",
                        lineColor: "#FFBC00"
                    });
                }
            }, 500); // run after mount
        };

        setTimeout(() => {
            hideLoader();
        }, 1000);

        document.body.appendChild(script);

        return () => {
            // cleanup
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            <nav className="navbar navbar-expand-md cus-bg-dark navbar-dark" id="sticky-header">
                <div className="container">
                    <a className="navbar-brand cus-navbar-logo" href="#"><img src="siteadmin/images/logo2.png" alt="" /> </a>

                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleNavbar}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a className="nav-link" href="#">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#aboutus">About Us</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#services">Services</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#">Contact</a>
                            </li>
                            {/* <!--<li className="nav-item">
                                    <a className="nav-link" href="pdf/">Business Plan</a>
                                </li>--> */}
                            <li className="nav-item">
                                <Link className="nav-link" to="/login">Login</Link>
                            </li>
                            <div className="header-button upper1">
                                <Link to="/login">Connect</Link>
                            </div>
                        </ul>
                    </div>
                </div>
            </nav>

            <div className="clearfix" style={{ clear: "both" }}></div>

            <div id="particles">
                <div id="webcoderskull">
                    <div className="hero-section style-two upper d-flex align-items-center" id="home">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="hero-content wow fadeInDown" data-wow-delay=".3">
                                        <div className="hero-title">
                                            <h1>Welcome To</h1>
                                            {/* <!--<h1>Digital Transaction</h1>--> */}
                                            <h3>Tethermine</h3>
                                            <div className="shape"></div>
                                        </div>
                                        <div className="hero-text">
                                            <p>Tethermine is a leading investment company that aims to help its customers achieve their financial goals through intelligent and diversified investments.</p>
                                        </div>
                                        <div className="hero-button">
                                            <Link to="/login">Get Started Now</Link>
                                        </div>
                                    </div>
                                    <div className="dreamit-hero-thumb">
                                        {/* <!-- <div className="hero-thumb-inner4 bounce-animate4">
                                    <img src="siteadmin/images/slider/half-circle.png" alt=""/>
                                </div>
                                <div className="hero-thumb-inner5 bounce-animate">
                                    <img src="siteadmin/images/slider/cross-2.png" alt=""/>
                                </div>--> */}
                                        {/* <!-- <div className="hero-thumb-inner6 bounce-animate2">
                                    <img src="siteadmin/images/slider/cross.png" alt=""/>
                                </div>--> */}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="dreamit-hero-thumb wow fadeInDown" data-wow-delay=".">
                                        <div className="hero-main-thumb">
                                            <img src="siteadmin/images/slider/main-img.png" alt="" />
                                        </div>
                                        <div className="hero-thumb-inner1 rotateme">
                                            <img src="siteadmin/images/slider/round.png" alt="" />
                                        </div>
                                        <div className="hero-thumb-inner2 bounce-animate">
                                            <img src="siteadmin/images/slider/style-1.png" alt="" />
                                        </div>
                                        <div className="hero-thumb-inner3 bounce-animate3">
                                            <img src="siteadmin/images/slider/style-2.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix" style={{ clear: "both" }}></div>
            {/* <!--==================================================--> */}
            {/* <!-- Start cryptobit feature Area --> */}
            {/* <!--==================================================--> */}
            <div className="feature-area style-two pt-90 pb-80" id="feature">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-sm-12">
                            <div className="dreamit-section-title style-two text-center pb-65">
                                <h4>Tethermine Features</h4>
                                <h1>The most trusted way for</h1>
                                <h1>Powerfull Influence</h1>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-single-box wow fadeInLeft" data-wow-delay=".3s">
                                <div className="feature-box-inner">
                                    <div className="feature-icon1">
                                        <i className="fa fa-anchor"></i>
                                    </div>
                                    <div className="feature-title">
                                        <h3>Transparency</h3>
                                        <p>Cryptography, encryption process referred to as plaintext</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-single-box upper1 wow fadeInLeft" data-wow-delay=".4s">
                                <div className="feature-box-inner">
                                    <div className="feature-icon1">
                                        <i className="fa fa-file"></i>
                                    </div>
                                    <div className="feature-title">
                                        <h3>External Method</h3>
                                        <p>Cryptography, encryption process referred to as plaintext</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-single-box upper2 wow fadeInLeft" data-wow-delay=".5s">
                                <div className="feature-box-inner">
                                    <div className="feature-icon1">
                                        <i className="fa fa-bug"></i>
                                    </div>
                                    <div className="feature-title">
                                        <h3>High Security</h3>
                                        <p>Cryptography, encryption process referred to as plaintext</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="feature-bottom-text text-center wow fadeInLeft" data-wow-delay=".6s">
                                <p> <i className="fa fa-lightbulb-o"></i> Do you Know More? <span><a href="#">Learn More</a></span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--==================================================--> */}
            {/* <!-- End cryptobit feature Area --> */}
            {/* <!--==================================================--> */}
            <div className="services-area style-two pt-90 pb-100" id="aboutus">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-sm-12">
                            <div className="dreamit-section-title text-center style-two pb-5 wow fadeInLeft" data-wow-delay=".3s">
                                {/* <!-- <h4>ABOUT US</h4>--> */}
                                <h1>About Us</h1>
                            </div>
                        </div>
                    </div>
                    <div className="row service-bg wow fadeInLeft" data-wow-delay=".5s">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="dreamit-section-title style-two">
                                <h1>Top Marketing Business in the</h1>

                                <h1>Worldwide</h1>
                                <p className="service-text">
                                    Tethermine is an innovative cryptocurrency designed to enhance arbitrage trading across decentralized finance (DeFi) platforms. Leveraging blockchain technology, it optimizes trading by exploiting price discrepancies, providing users with secure and profitable opportunities. Through automation and smart contracts, Tethermine reduces manual intervention and minimizes trading risks.
                                </p>
                            </div>
                            <div className="about-button2">
                                <a href="#">More Details</a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="service-single-thumb wow fadeInLeft" data-wow-delay=".6s">
                                <div className="service-main-thumb">
                                    <img src="siteadmin/images/resource/mobile-img.png" alt="" />
                                </div>
                                <div className="service-thumb-inner bounce-animate3">
                                    <img src="siteadmin/images/resource/coin.png" alt="" />
                                </div>
                                <div className="service-thumb-inner1 bounce-animate4">
                                    <img src="siteadmin/images/resource/half-circle-red.png" alt="" />
                                </div>
                                <div className="service-thumb-inner2 bounce-animate5">
                                    <img src="siteadmin/images/resource/half-cirlce-green.png" alt="" />
                                </div>
                                <div className="service-thumb-inner3 bounce-animate">
                                    <img src="siteadmin/images/resource/crosss-icon.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--==================================================--> */}
            {/* <!-- Start cryptobit about Area --> */}
            {/* <!--==================================================--> */}
            <div className="about-area style-two pt-100 pb-100" id="services">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="dreamit-about-thumb wow fadeInLeft" data-wow-delay=".3s">
                                <img src="siteadmin/images/resource/about-main-img.png" alt="" />
                                <div className="about-thumb-inner rotateme">
                                    <img src="siteadmin/images/resource/about-coin.png" alt="" />
                                </div>
                                <div className="about-thumb-inner1 bounce-animate3">
                                    <img src="siteadmin/images/resource/about-icon.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row wow fadeInLeft" data-wow-delay=".4s">
                                <div className="col-lg-12">
                                    <div className="dreamit-section-title style-two pb-2">
                                        <h4>
                                            Why Choose Insta USDT
                                        </h4>
                                        <h1>Blockchain will Record</h1>
                                        <h1>All Transactions</h1>
                                        <p className="section-text">
                                            Insta USDT recognizes the importance of diversifying investments to reduce risk and enhance potential returns. By allocating funds across multiple platforms, clients benefit from a balanced portfolio.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-single-icon-box wow fadeInLeft" data-wow-delay=".5s">
                                        <div className="about-icon">
                                            <i className="fa fa-lightbulb-o"></i>
                                        </div>
                                        <div className="about-title">
                                            <h4>Transparency</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-single-icon-box wow fadeInLeft" data-wow-delay=".6s">
                                        <div className="about-icon">
                                            <i className="fa fa-support"></i>
                                        </div>
                                        <div className="about-title">
                                            <h4>Risk Management</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-single-icon-box wow fadeInLeft" data-wow-delay=".7s">
                                        <div className="about-icon">
                                            <i className="fa fa-handshake-o"></i>
                                        </div>
                                        <div className="about-title">
                                            <h4>Long-term Vision</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-single-icon-box wow fadeInLeft" data-wow-delay=".8s">
                                        <div className="about-icon">
                                            <i className="fa fa-clock-o"></i>
                                        </div>
                                        <div className="about-title">
                                            <h4>Diversification</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-single-icon-box wow fadeInLeft" data-wow-delay=".8s">
                                        <div className="about-icon">
                                            <i className="fa fa-clock-o"></i>
                                        </div>
                                        <div className="about-title">
                                            <h4>Expert Guidance</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-button2 wow fadeInLeft" data-wow-delay=".9s">
                                        <a href="#">Contact More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="token-sale p-tb" id="token" style={{ background: "#f1f1f1" }}>
                <div className="container">
                    <div className="text-center">
                        <h2 className="section-heading">OUR STRENGTH &amp; TOOLS</h2>
                    </div>
                    <div className="sub-txt mw-650 text-center">
                        <p>
                            We Deal With The Multiple
                            Referral Plans and Services
                        </p>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="chart-img mobile-center ipad-center">
                                <img src="siteadmin/images/pie-chart-img1.png" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="chart-img mobile-center ipad-center">
                                <img src="siteadmin/images/sdimg1.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--==================================================--> */}
            {/* <!-- End cryptobit about Area --> */}
            {/* <!--==================================================--> */}
            {/* <!--==================================================--> */}
            {/* <!-- Start cryptobit feature Area --> */}
            {/* <!--==================================================--> */}
            {/* <!--==================================================--> */}
            {/* <!-- End cryptobit feature Area --> */}
            {/* <!--==================================================--> */}
            {/* <!--==================================================--> */}
            {/* <!-- Start cryptobit process Area --> */}
            {/* <!--==================================================--> */}
            <div className="process-area pt-80 pb-70" id="process">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-sm-12">
                            <div className="dreamit-section-title text-center style-two pb-5 wow fadeInLeft" data-wow-delay=".3s">
                                <h4>WORK PROCESS</h4>
                                <h1>Blockchain work Process</h1>
                                <p className="section-text">Rapidiously enhance service before multifunctional partnership cryptocurrency Energistically fabricate cross functional author done.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row process-bg">
                                <div className="col-lg-3 col-md-6">
                                    <div className="single-process-box wow fadeInLeft" data-wow-delay=".4s">
                                        <div className="single-process-thumb">
                                            <img src="siteadmin/images/resource/process1.png" alt="" />
                                            <div className="process-number">
                                                <span>01</span>
                                            </div>
                                        </div>
                                        <div className="single-process-content">
                                            <div className="process-title">
                                                <h4>Join Crypto</h4>
                                            </div>
                                            <div className="process-text">
                                                <p>Multifunctional partnershi Cryptocurrency</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="single-process-box wow fadeInLeft" data-wow-delay=".5s">
                                        <div className="single-process-thumb">
                                            <img src="siteadmin/images/resource/process2.png" alt="" />
                                            <div className="process-number">
                                                <span>02</span>
                                            </div>
                                        </div>
                                        <div className="single-process-content">
                                            <div className="process-title">
                                                <h4>Collect Bitcoin</h4>
                                            </div>
                                            <div className="process-text">
                                                <p>Multifunctional partnershi Cryptocurrency</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="single-process-box wow fadeInLeft" data-wow-delay=".6s">
                                        <div className="single-process-thumb">
                                            <img src="siteadmin/images/resource/process3.png" alt="" />
                                            <div className="process-number">
                                                <span>03</span>
                                            </div>
                                        </div>
                                        <div className="single-process-content">
                                            <div className="process-title">
                                                <h4>Start Selling</h4>
                                            </div>
                                            <div className="process-text">
                                                <p>Multifunctional partnershi Cryptocurrency</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="single-process-box wow fadeInLeft" data-wow-delay=".6s">
                                        <div className="single-process-thumb">
                                            <img src="siteadmin/images/resource/process4.png" alt="" />
                                            <div className="process-number">
                                                <span>04</span>
                                            </div>
                                        </div>
                                        <div className="single-process-content">
                                            <div className="process-title">
                                                <h4>Paid Member</h4>
                                            </div>
                                            <div className="process-text">
                                                <p>Multifunctional partnershi Cryptocurrency</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--==================================================--> */}
            {/* <!-- End Cryptobit process Area --> */}
            {/* <!--==================================================--> */}
            {/* <!--==================================================--> */}
            {/* <!-- Start Cryptobit testimonial Area --> */}
            {/* <!--==================================================--> */}
            {/* <!--==================================================--> */}
            {/* <!-- End Cryptobit testimonial Area --> */}
            {/* <!--==================================================--> */}
            {/* <!-- ===============//faq section start here \\================= --> */}
            <div className="faq-area style-two pt-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="dreamit-section-title style-two pb-2 wow fadeInLeft" data-wow-delay=".3s">
                                <h4>FAQ</h4>
                                <h1>Frequently Q/A</h1>
                                <p className="section-text">Globally network emerging action items with best-of-breed core <br />Efficiently build end-to-end mindshare</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="accordion-menu wow fadeInLeft" data-wow-delay=".5s">
                                <ul className="accordion">
                                    <li>
                                        <a>What is Blockchain?</a>
                                        <p>Globally network emerging action items with best-of-breed core Efficiently build end-to-end mindshare cultivate top-line web-readiness before 24/7 scenarios.</p>
                                    </li>
                                    <li>
                                        <a>Can I Transections Using Tokens?</a>
                                        <p>Globally network emerging action items with best-of-breed core Efficiently build end-to-end mindshare cultivate top-line web-readiness before 24/7 scenarios.</p>
                                    </li>
                                    <li>
                                        <a>How can I create a crypto-wallet?</a>
                                        <p>Globally network emerging action items with best-of-breed core Efficiently build end-to-end mindshare cultivate top-line web-readiness before 24/7 scenarios.</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="faq-single-thumb wow fadeInLeft" data-wow-delay=".6s">
                                <img src="siteadmin/images/resource/faq1.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- ===============//faq section end here \\=================== -->
    <!-- ===============//subscribe area end here \\=================== --> */}
            <div className="subscribe-area pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="single-subscribe-box wow fadeInLeft" data-wow-delay=".3s">
                                <div className="subscribe-title text-center">
                                    <h1>Stay with Us the Next Update</h1>
                                    <p>Principle-centered in a e-service with ethical total linkage. Phosfluo grow cutting edge technology vis-a-vis viral total</p>
                                </div>
                                <div className="contact-form-box-2 text-center wow fadeInLeft" data-wow-delay=".4s">
                                    <div className="from-box2">
                                        <input type="text" placeholder="Enter Your E-Mail" />
                                        <button>Subscribe</button>
                                    </div>
                                    <div id="status"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- ===============//subscribe area end here \\=================== --> */}
            {/* <!--==================================================--> */}
            {/* <!-- Start Cryptobit Footer Middle Area --> */}
            {/* <!--==================================================--> */}
            <div className="footer-middle style-two pt-80 pb-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="widgets-company-info  pt-3 wow fadeInLeft" data-wow-delay=".4s">
                                <div className="cryptobit-logo">
                                    <a className="logo_img" href="#" title="cryptobit">
                                        <img src="siteadmin/images/logo2.png" alt="" />
                                    </a>
                                </div>
                                <div className="company-info-desc">
                                    <p>
                                        Welcome to Tethermine, We believe in the power of community and collaboration to bring about positive change and growth.
                                    </p>
                                </div>
                                <div className="company_icon">
                                    <a className="facebook" href="#"><i className="fa fa-facebook"></i></a>
                                    <a className="twitter" href="#"><i className="fa fa-twitter"></i></a>
                                    <a className="linkedin" href="#"><i className="fa fa-linkedin"></i></a>
                                    <a className="pinterest" href="#"><i className="fa fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <div className="widget-nav-menu wow fadeInLeft" data-wow-delay=".5s">
                                        <h4 className="widget-title">Catagories</h4>
                                        <div className="menu-quick-link-content">
                                            <ul className="menu">
                                                <li><a href="#">What is ICO</a></li>
                                                <li><a href="#">Token</a></li>
                                                <li><a href="#">Road Map</a></li>
                                                <li><a href="#">Advisor</a></li>
                                                <li><a href="#">Payments</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="widget-nav-menu upper wow fadeInLeft" data-wow-delay=".6s">
                                        <h4 className="widget-title">Useful Link</h4>
                                        <div className="menu-quick-link-content">
                                            <ul className="menu">
                                                <li><a href="#">Privacy Policy</a></li>
                                                <li><a href="#">Terms of Services</a></li>
                                                <li><a href="#">Refund & Cancellation</a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="widget-nav-menu upper1 wow fadeInLeft" data-wow-delay=".7s">
                                        <h4 className="widget-title">Contact</h4>
                                        <div className="menu-quick-link">
                                        </div>
                                        <div className="contact-form-box-2 text-center">
                                            <div className="cus-text-footer-area">
                                                {/* <p>
                                                    <span>Address -</span> Delhi, India
                                                </p> */}
                                                <p>
                                                    <span>Email id -</span> support@tethermine.io
                                                </p>
                                                {/* <p>
                                                    <span>Phone No.</span> +91-9336914567
                                                </p> */}
                                            </div>
                                            <div className="from-box1">
                                                <input type="text" placeholder="Enter Your E-Mail" />
                                                <button type="button"><i className="fa fa-paper-plane"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row footer-bottom mt-65 wow fadeInLeft" data-wow-delay=".8s">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="footer-bottom-content">
                                <div className="footer-bottom-content-copy">
                                    <p>© Tethermine, 2025. <span> All Rights Reserved.</span></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="footer-bottom-shape">
                                <img src="siteadmin/images/resource/footer-b.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--==================================================--> */}
            {/* <!-- End Cryptobit Footer Middle Area --> */}
            {/* <!--==================================================--> */}
            {/* <!--==================================================--> */}
            {/* <!-- Start scroll Area --> */}
            {/* <!--==================================================--> */}
            <div className="scroll-area" >
                <div className="top-wrap">
                    <div className="go-top-btn-wraper">
                        <div className="go-top go-top-button">
                            <a href="#" className="w-100 h-100">
                                <i className="fa fa-arrow-up"></i>
                                <i className="fa fa-arrow-up"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default DefaultHome;
